import { render, staticRenderFns } from "./OcAndPositionForm.vue?vue&type=template&id=731b8ca7&"
import script from "./OcAndPositionForm.vue?vue&type=script&lang=js&"
export * from "./OcAndPositionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports